import { PracticeTreatmentContracts } from "@physiofit-digital/physiofit_types";
import { doc, onSnapshot } from "firebase/firestore";
import { useEffect } from "react";
import { getCurrentPracticeId } from "../../../core/store/chainSlice";
import { useMainStore } from "../../../core/store/mainStore";
import { db } from "../../../firebaseConfig";

export const useGetTreatmentContracts = () => {
  const currentPracticeId = useMainStore(getCurrentPracticeId);
  const setCurrentPracticeTreatmentContracts = useMainStore(
    (state) => state.setCurrentPracticeTreatmentContracts,
  );

  useEffect(() => {
    // Without this the hook subscribed to practices/undefined/documents/...,
    // a well-formed path to a document that cannot exist, so the listener never
    // resolved and any previously loaded contracts stayed on screen.
    if (!currentPracticeId) {
      setCurrentPracticeTreatmentContracts(undefined);
      return;
    }
    const unsub = onSnapshot(
      doc(
        db,
        "practices/" +
          currentPracticeId +
          "/documents/practiceTreatmentContracts",
      ),
      (doc) => {
        const data = doc.data() as PracticeTreatmentContracts;
        if (data) {
          setCurrentPracticeTreatmentContracts(data);
        }
      },
      (error) => {
        // Reading this requires a signed-in user, so the listener dies during
        // sign-out while the form is still mounted. Clearing beats keeping
        // another practice's contracts, which drive the cost bearer question.
        // A denial is terminal, so this cannot flap.
        console.error("Treatment contracts listener failed:", error);
        setCurrentPracticeTreatmentContracts(undefined);
      },
    );

    return () => unsub();
  }, [currentPracticeId]);
};
